import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';

export default function RequireRole({ roles, children }) {
  const { user, role, loading } = useAuth();
  const location = useLocation();

  if (loading) return null;
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (roles && !roles.includes(role)) {
    // If user has a valid role but not for this route, redirect to appropriate dashboard
    if (role === 'mentor') {
      return <Navigate to="/mentor" replace />;
    } else if (role === 'admin') {
      return <Navigate to="/" replace />;
    } else {
      // Unknown role, redirect to login
      return <Navigate to="/login" replace />;
    }
  }
  return children ?? <Outlet />;
}
